/**
 * 医生标签模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取医生标签列表
export const doctorLabelList = (params) => {
  return req.get('/hosp/doctor/label/list', params);
}

// 新增医生标签
export const doctorLabelAdd = (params) => {
  return req.post('/hosp/doctor/label', params);
}

// 修改医生标签
export const doctorLabelEdit = (params) => {
  return req.put('/hosp/doctor/label', params);
}

// 删除医生标签
export const doctorLabelDelete = (doctorLabelIdss) => {
  return req.delete(`/hosp/doctor/label/${doctorLabelIdss}`);
}